import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClientStorageService {
  public claims: Record<string, any> = {};

  public get campaignTag(): string | undefined {
    return sessionStorage.getItem('campaignTag') ?? undefined;
  }

  public set campaignTag(value: string | undefined) {
    if (!value) {
      sessionStorage.removeItem('campaignTag');
      return;
    }
    sessionStorage.setItem('campaignTag', value);
  }

  public clear(): void {
    this.claims = {};
    sessionStorage.removeItem('campaignTag');
  }
}
